import {
  USER_LOCK_FETCH_START,
  USER_LOCK_FETCH_END,
  USER_LOCK_LIST_SUCCESS,
  USER_LOCK_DETAIL_SUCCESS,
} from '../../../actions/Auth/UserLock/ActionTypes';

const initialState = {
  loading: false,
  userLockData: [],
  userLockDetail: null,
};

const UserLockReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOCK_FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case USER_LOCK_FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case USER_LOCK_LIST_SUCCESS:
      return {
        ...state,
        userLockData: action.data,
      };
    case USER_LOCK_DETAIL_SUCCESS:
      return {
        ...state,
        userLockDetail: action.data,
      };
    default:
      return state;
  }
};

export default UserLockReducer;
